import { Module } from "wrapper6";
import Glide from '@glidejs/glide'
import SimpleLightbox from 'simple-lightbox';
import { ArrowControls } from '../utils/_glide-plugins';

export default class CoverSlider extends Module {
  ready(app) {
    const COVER_SLIDER_WRAP = document.querySelector('.mtt-cover-slider');
    this.sliding = false;

    if (COVER_SLIDER_WRAP) {
      const GLIDE_OPTIONS = {
        type: 'carousel',
        // swipeThreshold: false,
        // dragThreshold: false,
        perView: 1,      
        gap: 240,  
        breakpoints: {
            1650: {
                gap: 120
            },
            1100: {
                gap: 10,
                swipeThreshold: true,
                dragThreshold: true,
            }
        }                   
      }

      const SLIDER = new Glide('.mtt-cover-slider__slider', GLIDE_OPTIONS);    

      SLIDER.mount();    

      this.addArrowsFunctionality(SLIDER);
    }
  }  

    addArrowsFunctionality(slider) {

        slider.on('run.after', () => {
            this.fadeNonActiveImage();
        });

        document.querySelector('.mtt-cover-slider__button-left').addEventListener('click', () => {
            slider.go('<');
        });

        document.querySelector('.mtt-cover-slider__button-right').addEventListener('click', () => {
            slider.go('>');
        });         
    }
    

    fadeNonActiveImage() {
        const NON_ACTIVE_IMAGES = document.querySelectorAll('.mtt-cover-slider .glide__slide:not(.glide__slide--active) .object-fit img');

        for (let i = 0; i < NON_ACTIVE_IMAGES.length; i++) {
            const IMAGE = NON_ACTIVE_IMAGES[i];            
            IMAGE.classList.add('fade');
        }        
                
        document.querySelector('.mtt-cover-slider .glide__slide--active .object-fit img').classList.remove('fade');
    }  
}